import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as cursorUsageEvent from '../cursor-usage-event'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: cursorUsageEvent.RESOURCE.payload.dimension.partialId,
      partialId: cursorUsageEvent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The estimated cost, in USD, of this event.',
    isOptional: true,
    name: 'Estimated Cost (USD)',
    partialId: PartialId.Standard.create('est_cost_usd'),
    type: core.common.value.types.Intrinsic.Currency,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
